




























































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';
import '@/compiled-icons/arrow-left';
import '@/compiled-icons/arrow-right';
import '@/compiled-icons/skip-next';
import '@/compiled-icons/skip-previous';


export interface PaginationEvent {
  forceLastPage?: boolean;
  page?: number;
}

@Component({
  name: 'ametras-custom-pagiantion-template',
  components: {
    AmetrasNumberFieldTemplate
  }

})
export default class AmetrasCustomPaginationTemplate extends Vue {

  @Prop() loading!: boolean;
  @Prop() length!: number;
  @Prop() offset!: number;
  @Prop() value!: number;

  internalLoading = false;
  internalValue: number = 0;
  hasNextPage: boolean = true;
  manualPage: number = 0;

  created() {
    this.internalValue = this.value + this.offset;
    if (this.length === 1) {
      this.hasNextPage = false;
    }
  }

  @Watch('value') modelChanges(newValue: number) {
    this.internalValue = newValue + this.offset;

    if (this.length > this.internalValue) {
      this.hasNextPage = true;
    } else {
      this.hasNextPage = false;
    }
  }

  @Watch('length') lengthChanges(newValue: number) {
    if (newValue > this.internalValue) {
      this.hasNextPage = true;
    } else {
      this.hasNextPage = false;
    }
  }

  @Watch('loading') loadingChanged(newValue: boolean) {
    if (newValue === false) {
      this.internalLoading = false;
    }
  }

  onClickPrev() {
    this.internalValue = this.internalValue - this.offset;
    this.calculatePageAndSendEvent();
    this.enableInternalLoading();
  }

  onClickNext() {
    this.internalValue = this.internalValue + this.offset;
    this.calculatePageAndSendEvent();
    this.enableInternalLoading();
  }

  onFirstPageClick() {
    this.internalValue = 1;
    this.calculatePageAndSendEvent();
    this.enableInternalLoading();
  }

  onLastPageClick() {
    const requestedPage = {
      forceLastPage: true
    };
    this.publishPaginationData(requestedPage);
    this.enableInternalLoading();
  }

  calculatePageAndSendEvent() {
    this.publishPaginationData({page: this.internalValue - this.offset});
  }


  publishPaginationData(paginationEvent: PaginationEvent) {
    this.$emit('change', paginationEvent);
  }

  manualChange() {
    let reloadNeeded = false;
    if (this.internalValue !== this.manualPage) {
      reloadNeeded = true;
    }

    this.internalValue = this.manualPage;
    this.calculatePageAndSendEvent();

    this.$nextTick(() => {
      this.manualPage = 0;
    });

    if (reloadNeeded) {
      this.enableInternalLoading();
    }
  }

  enableInternalLoading() {
    this.internalLoading = true;
  }

}

